import React from "react";
import { Button, Input } from "reactstrap";
import { customFieldsCopy } from "./copy";

type DraftOption = {
  id?: string | null;
  label: string;
  active?: boolean;
  used?: boolean;
};

type Props = {
  options: DraftOption[];
  disabled?: boolean;
  onChange: (next: DraftOption[]) => void;
};

const TaxonomyOptionEditor = ({ options, onChange, disabled }: Props) => {
  const rows = options?.length ? options : [{ label: "", active: true }];

  const update = (index: number, patch: Partial<DraftOption>) => {
    onChange(rows.map((row, i) => (i === index ? { ...row, ...patch } : row)));
  };

  return (
    <div className="hkp-tax-options">
      {rows.map((row, index) => (
        <div className="hkp-tax-option-row" key={row.id || `new-${index}`}>
          <Input
            disabled={disabled}
            value={row.label}
            placeholder={`Option ${index + 1}`}
            onChange={(e) => update(index, { label: e.target.value })}
            aria-label={`Option ${index + 1}`}
          />
          {row.id ? (
            <Button
              color="secondary"
              outline
              size="sm"
              type="button"
              disabled={disabled}
              onClick={() => update(index, { active: row.active === false })}
            >
              {row.active === false ? customFieldsCopy.reEnable : "Deactivate"}
            </Button>
          ) : (
            <Button
              color="danger"
              outline
              size="sm"
              type="button"
              onClick={() => onChange(rows.filter((_, i) => i !== index))}
              disabled={disabled || rows.length <= 1}
            >
              Remove
            </Button>
          )}
          {row.id ? <p className="text-muted small mb-0">{customFieldsCopy.optionUsedHint}</p> : null}
        </div>
      ))}
      <Button
        color="primary"
        outline
        size="sm"
        type="button"
        disabled={disabled}
        onClick={() => onChange([...rows, { label: "", active: true }])}
      >
        {customFieldsCopy.addOption}
      </Button>
    </div>
  );
};

export default TaxonomyOptionEditor;
export type { DraftOption };
